export default "__VITE_ASSET__BY$NX2Nt__"